// TODO : Change to default frontend footer
<script setup>
  import {Head as InertiaHead} from "@inertiajs/vue3";

  defineOptions({
    name: "ComponentPatientinputLayout",
  });

  defineProps({
    title: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <InertiaHead :title="title" class="print:hidden" />

    <div id="patientinput-layout-header" class="flex items-center justify-center px-4 py-2 empty:hidden print:hidden" />

    <main class="grow px-2 pb-4 md:px-4">
      <div class="mx-auto h-full max-w-xl">
        <slot />
      </div>
    </main>

    <footer class="bg-gray-200 print:hidden">
      <div
        class="mx-auto max-w-(--breakpoint-lg) px-4 py-6 md:flex md:flex-row-reverse md:flex-wrap md:items-center md:justify-between"
      >
        <ul class="flex items-center space-x-8">
          <li>
            <a
              class="text-gray-900 no-underline hover:underline"
              target="_blank"
              href="https://medicheck.pharma4u.de/url-redirect/accessibility-status"
            >
              Barrierefreiheit
            </a>
          </li>
          <li v-if="$page.props.privacyPolicyUrl">
            <a class="text-gray-900 no-underline hover:underline" target="_blank" :href="$page.props.privacyPolicyUrl">
              Datenschutz
            </a>
          </li>
          <li>
            <a
              class="text-gray-900 no-underline hover:underline"
              target="_blank"
              href="https://www.pharma4u.de/impressum"
            >
              Impressum
            </a>
          </li>
        </ul>

        <p class="text-gray-900">&copy; {{ new Date().getFullYear() }} pharma4u GmbH</p>
      </div>
    </footer>
  </div>
</template>
